import dayjs from 'dayjs';
import { ITransaction } from '../../../interface/transaction';

const toComparableFormValues = (
  transaction: ITransaction | null | undefined,
  subject: string | undefined,
) => ({
  matterId: transaction?.matter?.id ?? null,
  transactionTypeId: transaction?.transactionType?.id ?? null,
  subject: subject || null,
  description: transaction?.description || null,
  transactionDate: dayjs(transaction?.transactionDate).format('YYYY-MM-DD'),
  skillId: transaction?.skill?.id ?? null,
  matterPhaseId: transaction?.matterPhaseId ?? null,
  invoiceableType: transaction?.invoiceableType ?? transaction?.matter?.invoiceableType ?? null,
  mailAsNote: transaction?.mailAsNote ?? false,
  workedHours: Number(transaction?.workedHours ?? 0),
  billableQuantity: Number(transaction?.billableQuantity ?? 0),
  unitPrice: Number(transaction?.unitPrice ?? 0),
});

export const isTransactionFormChanged = (
  transaction: ITransaction | null | undefined,
  initialTransaction: ITransaction | null | undefined,
  isEditMode: boolean,
): boolean => {
  const currentValues = toComparableFormValues(transaction, transaction?.currentSubject);
  const initialValues = toComparableFormValues(
    initialTransaction,
    isEditMode ? initialTransaction?.subject : undefined,
  );

  return (Object.keys(currentValues) as (keyof typeof currentValues)[]).some(
    (field) => currentValues[field] !== initialValues[field],
  );
};
